var React = require('react');

function Waypoint (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5.577C4.508.577.446 4.652.446 9.66c0 6.216 8.102 15.342 8.447 15.728a.814.814 0 001.214 0c.345-.386 8.447-9.512 8.447-15.728 0-5.01-4.062-9.084-9.054-9.084zm0 13.654c-2.512 0-4.555-2.05-4.555-4.57 0-2.52 2.043-4.57 4.555-4.57 2.512 0 4.555 2.05 4.555 4.57 0 2.52-2.043 4.57-4.555 4.57z","fill":"#fff"}));
}

Waypoint.defaultProps = {"width":"19","height":"26","viewBox":"0 0 19 26","fill":"none"};

module.exports = Waypoint;

Waypoint.default = Waypoint;
